module.exports = __webpack_public_path__ + "static/media/agree.79934080.png";